import styled from 'styled-components';
import { Dropdown } from 'react-bootstrap';

export const StyledDivDropdown = styled.div`
  border-radius: 5px;
  border: 1px solid lightgray;
  margin-top: 5px;
  position: absolute;
  z-index: 99999999999;
  background: white;
  width: 100%;
`;

export const StyledDropdown = styled(Dropdown)`
  .dropdown {
    width: 100% !important;
  }

  .dropdown-item {
    white-space: unset !important;
  }
`;